// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const TemporaryInviteRequiresPresenceModal = observer(() => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`Gateway Connection Required`}
			description={t`You must be connected to the gateway to accept this temporary invite. Please check your connection and try again.`}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
